import classNames from 'classnames';
import { forwardRef } from 'react';
const dotCss = "dg6pyn9";
export const Dot = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(dotCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");